import styled from "styled-components";

export const Logo = styled.a`
    display: flex;
    gap: 8px;
`

export const LogoImg = styled.img`
    aspect-ratio: 1;
    width: 20px;
`

export const LogoName = styled.p`
    font-weight: 500;
`
